module.exports = __webpack_public_path__ + "img/worldofzain-continent.62ae894b.jpg";